import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Alert, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Save } from '@mui/icons-material';
import api from '../../service/api';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function PotentialMatchConfirm(props) {
  const { open, onClose, data, selectedProfile, profileInfo } = props
  let referenceId = null
  if (profileInfo?.attributes?.HCPReferenceId && profileInfo?.attributes?.HCPReferenceId[0].value) {
    referenceId = profileInfo?.attributes?.HCPReferenceId[0].value
  }


  const [comment, setComment] = React.useState('')
  const [submitButtonState, setSubmitButtonState] = React.useState(false)
  const [apiResponse, setApiResponse] = React.useState(null)

  React.useEffect(() => {
    setComment('')
    setSubmitButtonState(false)
    setApiResponse(null)
  }, [open])

  const handleConfirm = () => {


    setSubmitButtonState(true)
    api.confirmPotentialMatch({
      id: data.Id,
      selectedProfile: selectedProfile,
      comment: comment
    }).then(res => {
      setApiResponse({
        severity: 'success',
        message: 'DCR submitted successfully'
      })
    }).catch(err => {
      setApiResponse({
        severity: 'error',
        message: `${err.response.data}`
      })
    }).finally(() => {
      setSubmitButtonState(false)
    })
    
    // onConfirm(data)
  }

  let message = `You have not selected any profile. This will be considered as a new hcp and a DCR will be sent to IQVIA`
  if (selectedProfile && selectedProfile !== '') {
    message = `You have selected the profile with HCP Reference ID: ${referenceId}. DCR will be sent to this IQVIA profile`
  }

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Confirm
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>

          {/* api success/failure message*/}
          {apiResponse && <>
            <Alert severity={apiResponse.severity}>
              {apiResponse.message}
            </Alert>
          </>}

          {/* show message until api call */}
          {!apiResponse &&
            <Typography
              color="neutral"
              level="title-md"
              variant="plain">
              {message}<br /><br />
            </Typography>}

          {/* show comment box if not api success */}
          {(!apiResponse || apiResponse.severity === 'error') && <>
            <Typography
              color="neutral"
              level="title-md"
              variant="plain">
              Comments *
            </Typography>
            <TextField
              placeholder=""
              rows={4}
              onChange={(event) => {
                setComment(event.target.value)
              }}
              error={!!!comment}
              helperText={comment ? '' : "Comment is required"}
              fullWidth
              multiline />
          </>}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={onClose}>
            Close
          </Button>
          {/* show submit only if error/not submitted */}
          {(!apiResponse || apiResponse.severity === 'error') && <>
            <LoadingButton
              variant="contained"
              disabled={!!!comment}
              loading={submitButtonState}
              loadingPosition="start"
              startIcon={<Save />}
              color="error"
              onClick={handleConfirm}>
              Confirm
            </LoadingButton></>}
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
